import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e052be58"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 1 }
const _hoisted_2 = { class: "top-ten-wrapper" }
const _hoisted_3 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SpinnerLoader = _resolveComponent("SpinnerLoader")!
  const _component_RowComponent = _resolveComponent("RowComponent")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_TopTenListComponent = _resolveComponent("TopTenListComponent")!
  const _component_MainLayout = _resolveComponent("MainLayout")!

  return (_openBlock(), _createBlock(_component_MainLayout, null, {
    default: _withCtx(() => [
      (_ctx.isLoading)
        ? (_openBlock(), _createBlock(_component_SpinnerLoader, { key: 0 }))
        : (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_RowComponent, null, {
              title: _withCtx(() => [
                _createTextVNode("YOUR STATS")
              ]),
              _: 1
            }),
            _createVNode(_component_v_divider),
            _createVNode(_component_RowComponent, null, {
              title: _withCtx(() => [
                _createTextVNode("ARTISTS")
              ]),
              count: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.artistsCount), 1)
              ]),
              action: _withCtx(() => [
                (_ctx.isGalleryOrPrivateSeller)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      type: "button",
                      class: "btn",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/artists')))
                    }, " VIEW ARTISTS "))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_v_divider),
            _createVNode(_component_RowComponent, null, {
              title: _withCtx(() => [
                _createTextVNode("ARTWORKS")
              ]),
              count: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.artworksDetails.total), 1)
              ]),
              details: _withCtx(() => [
                _createElementVNode("div", null, [
                  _createElementVNode("p", null, "LIVE ON ARTSCOOPS: " + _toDisplayString(_ctx.artworksDetails.live), 1),
                  _createElementVNode("p", null, "FOR SALE: " + _toDisplayString(_ctx.artworksDetails.for_sale), 1),
                  _createElementVNode("p", null, "PENDING GOING LIVE: " + _toDisplayString(_ctx.artworksDetails.pending), 1)
                ])
              ]),
              action: _withCtx(() => [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push('/artworks/new')))
                }, " ADD ARTWORK ")
              ]),
              _: 1
            }),
            _createVNode(_component_v_divider),
            (_ctx.type !== 'private_seller')
              ? (_openBlock(), _createBlock(_component_RowComponent, { key: 0 }, {
                  title: _withCtx(() => [
                    _createTextVNode("SHOWS")
                  ]),
                  count: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.showsCount), 1)
                  ]),
                  action: _withCtx(() => [
                    (_ctx.isGalleryOrPrivateSeller)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          type: "button",
                          class: "btn",
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$router.push('/shows/add')))
                        }, " ADD SHOW "))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_v_divider),
            (_ctx.type !== 'private_seller')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createVNode(_component_RowComponent, null, {
                    title: _withCtx(() => [
                      _createTextVNode("ANALYTICS")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_divider),
                  _createElementVNode("div", _hoisted_2, [
                    (_ctx.isGalleryOrPrivateSeller)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                          _createVNode(_component_TopTenListComponent, {
                            items: _ctx.artistsAnalytics,
                            title: "artists"
                          }, null, 8, ["items"])
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", null, [
                      _createVNode(_component_TopTenListComponent, {
                        items: _ctx.artworksAnalytics,
                        title: "artworks"
                      }, null, 8, ["items"])
                    ]),
                    _createElementVNode("div", null, [
                      _createVNode(_component_TopTenListComponent, {
                        items: _ctx.countriesAnalytics,
                        title: "countries"
                      }, null, 8, ["items"])
                    ])
                  ])
                ], 64))
              : _createCommentVNode("", true)
          ]))
    ]),
    _: 1
  }))
}